import { render, staticRenderFns } from "./dulipage.vue?vue&type=template&id=1f1d275e&scoped=true&"
import script from "./dulipage.vue?vue&type=script&lang=js&"
export * from "./dulipage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1d275e",
  null
  
)

export default component.exports